class MasonryController {

  // constructor, set_grid en execute in volgorde laden onderaan de pagina

  constructor() {
    this.gridElement = null; // element
    this.$grid = null; // actief grid

    window.addEventListener('filters_changed', this.on_filters_change.bind(this) );
  }

  set_grid(elem) {
    this.gridElement = elem
  }

  execute() {
    if( this.gridElement == null ) return this.err_log('Grid is niet gezet');
    this.$grid = this.gridElement.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer'
      }
    });
  }

  on_state_change(oldstate, newstate) {
    // console.log( 'state:', oldstate, 'to', newstate );
    // body position fixed op timeout?
  }

  on_filters_change(event) {
    let $grid_items = this.$grid.find('[data-project-sector].grid-item');
    $grid_items.addClass('show-item');

    if( event.detail.filters ) {
      if( event.detail.filters['project-sector'].length > 0) {
        $grid_items.each( function(index, item) {
          let $item = jQuery(item);
          let sectorArr = JSON.parse($item.attr('data-project-sector'));
          let exists = sectorArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-sector']) !== -1);
          if( !exists ) $item.removeClass('show-item');
        });
      }
      if( event.detail.filters['project-expertise'].length > 0) {
        $grid_items.each( function(index, item) {
          let $item = jQuery(item);
          let expertiseArr = JSON.parse($item.attr('data-project-expertise'));
          let exists = expertiseArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-expertise']) !== -1);
          if( !exists ) $item.removeClass('show-item');
        });
      }
    }

  }

  err_log( msg ) {
    console.log(msg);
    return false;
  }

}